import { render, staticRenderFns } from "./triggers.vue?vue&type=template&id=14cecca5&scoped=true&"
import script from "./triggers.vue?vue&type=script&lang=ts&"
export * from "./triggers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cecca5",
  null
  
)

export default component.exports